var React = require('react');
var createReactClass = require('create-react-class');

var PracticeFooter = createReactClass({
  render: function () {
    const {
      name: practiceName,
      address: {
        street,
        street2 = '',
        street3 = '',
        city,
        state,
        postalCode,
      } = {},
    } = this.props.practice;

    const practiceAddress = [street, street2, street3];

    const practiceLocality = [city, state, postalCode];

    return (
      <footer id="footer">
        <address>
          {practiceName}
          <br />
          {practiceAddress.filter((el) => Boolean(el)).join(<br />)}
          <br />
          {practiceLocality.join(' ')}
        </address>
      </footer>
    );
  },
});

module.exports = PracticeFooter;



// WEBPACK FOOTER //
// ./src/common/routes/practice/components/practiceFooter.jsx